import React, { ElementType, ReactNode } from "react";
import "./Translatable.css";
import { useTranslatedTextState } from "../../contexts/TranslationContext";

interface TranslatableProps {
  children: ReactNode;
  as?: ElementType;
  className?: string;
  style?: React.CSSProperties;
  capitalize?: boolean;
  titleCase?: boolean;
}

const extractText = (children: ReactNode): string | null => {
  if (typeof children === "string") return children;
  if (typeof children === "number") return String(children);
  if (Array.isArray(children) && children.every((c) => typeof c === "string" || typeof c === "number")) {
    return children.join("");
  }
  return null;
};

export const Translatable: React.FC<TranslatableProps> = ({
  children,
  as,
  className,
  style,
  capitalize,
  titleCase,
}) => {
  const Tag = (as ?? "div") as ElementType;
  const source = extractText(children);
  const { value: translated, isTranslating } = useTranslatedTextState(source ?? "", { capitalize, titleCase });

  const classes = ["translatable", isTranslating ? "translatable--pending" : "", className]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag data-translate className={classes} style={style}>
      {source === null ? children : translated}
    </Tag>
  );
};

export default Translatable;
